import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { PackageDTO, DetailDTO } from '@app/src/views/Package/listPackage/dtos';
import { PackageModel, DetailModel } from '@app/src/views/Package/listPackage/models/PackageModel';
import { PackageAvailableDTO, PackageAvailableDetailDTO, ExtrachargeAvailableDetailDTO } from '@app/src/views/Package/listPackage/dtos/PackageAvailableDTO';
import { PackageAvailableModel, ExtrachargeAvailableDetailModel, PackageAvailableDetailModel } from '@app/src/views/Package/listPackage/models/PackageAvailableModel';

export const hydrateData = (data: PackageDTO[]) => data.map((item) => ({
  state: item.state,
  priceIgv: item.price_igv,
  priceRegular: item.regular_price,
  order: item.order,
  name: item.name,
  price: item.price,
  alias: item.alias,
  saving: item.saving,
  id: item.id,
  idSpecial: item.special_id,
  title: item.title,
  recommended: item.recommended,
  duration: item.duration,
  detail: {
    ads: hydrateDetail(item.detail.ads),
    extracharges: hydrateDetail(item.detail.extracharges)
  }
})) as PackageModel[];

const hydrateDetail = (data: DetailDTO[]) => data.map((item) => ({
  idExtracharge: item.extracharge_id,
  quantity: item.quantity,
  price: item.price,
  description: item.description,
  state: item.state,
  id: item.id,
  alias: item.alias,
  idPackage: item.package_id,
  publication: item.publication
})) as DetailModel[];


export const hydratePackageConsume = (data: PackageAvailableDTO) => ({
  totalAds: data.total_ads,
  totalPackages: data.total_packages,
  packages: data && data.packages && hydratePackageDetailConsume(data.packages)
}) as PackageAvailableModel;

const hydratePackageDetailConsume = (data: PackageAvailableDetailDTO[]) => data.map((item) => ({
  name: item.name,
  categoryId: item.category_id,
  categoryName: item.category_name,
  expirationDate: item.expiration_date,
  quantityAds: item.quantity_ads,
  ads: item.ads,
  extracharges: hydrateExtrachargesConsume(item.extracharges),
  pathConsume: CATEGORIES[CATEGORY[item.category_id]].paths.consumePackage.stepOne,
  pathPurchasePackage: CATEGORIES[CATEGORY[item.category_id]].paths.purchasePackage.stepSelection,
  urlPosting: item.url_posting
})) as PackageAvailableDetailModel[];

const hydrateExtrachargesConsume = (data: ExtrachargeAvailableDetailDTO[]) => data.map((item) => ({
  extrachargeId: item.extracharge_id,
  total: item.total,
  stock: item.stock,
  name: item.name
})) as ExtrachargeAvailableDetailModel[];